import templateUrl from "./cmvr-center-list.html";
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";

export const cmvrCenterListComponent = {
  bindings: {
    details: "<",
  },
  templateUrl,

  controller: class CMVRCenterListComponent {
    constructor(CMVRCenterService, ModalService, $state, toastr) {
      "ngInject";
      this.CMVRCenterService = CMVRCenterService;
      this.modalService = ModalService;
      this.$state = $state;
      this.toastr = toastr;
    }
    $onInit() {
      this.noData = this.details.list.length === 0;
      if (this.details.list.length > 0) {
        this.details.list = this.formatData(this.details.list);
      }
      this.itemPerPage = 10;
      this.currentPage = 1;
      this.searchKeyword = "";
    }
    formatData(list) {
      const phoneUtil = PhoneNumberUtil.getInstance();
      return list.map((value) => {
        // format phone number
        const number = phoneUtil.parseAndKeepRawInput(
          value.phoneNumber,
          value.phoneCountryCode
        );
        value.phoneNumberFormat = phoneUtil.format(
          number,
          PhoneNumberFormat.NATIONAL
        );
        value.formattedAddress = this.formatAddress(value.location);
        return value;
      });
    }
    formatAddress(address) {
      return address
        ? `${address.addressLine1 + ", "}${
            address.addressLine2 ? address.addressLine2 + ", " : ""
          }${address.cityName},
			${address.stateName} ${address.zipcode ? address.zipcode : ""}`
        : "";
    }
    onChangePage(pageId) {
      this.currentPage = pageId;
      // fetch the data for the given page
      this.CMVRCenterService.getCMVRCenterList(
        pageId,
        this.itemPerPage,
        this.searchKeyword
      ).then((result) => {
        this.details.list = this.formatData(result.details.list);
      });
    }
    onChangeSearchKeyword(value) {
      this.searchKeyword = value;
      this.currentPage = 1;
      this.CMVRCenterService.getCMVRCenterList(
        this.currentPage,
        this.itemPerPage,
        this.searchKeyword
      ).then(({ details }) => {
        this.details = details;
      });
    }
    onDelete(center) {
      this.CMVRCenterService.getVeteransCountInCMVRCenter(center.cmvrCenterId)
        .then((response) => {
          // give a warning message, since veterans area assigned to the given cmvr center
          const bodyMsg = response.details.count
            ? "There are members assigned to this CMVR Center, are you sure to delete it?"
            : "Are you sure to delete it?";
          this.modalService.open({
            details: {
              bodyMessage: bodyMsg,
            },
            buttons: [
              {
                name: "No",
                action() {},
              },
              {
                name: "Yes",
                isPrimary: true,
                action: _onDelete.bind(this),
              },
            ],
          });
          function _onDelete() {
            this.CMVRCenterService.deleteCMVRCenter(center.cmvrCenterId)
              .then((_) => {
                this.toastr.success("CMVR Center deleted successfully!!");
                this.$state.reload();
              })
              .catch((err) => {
                this.toastr.error(err);
              });
          }
        })
        .catch((err) => {
          this.toastr.error(err);
        });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/cmvr-center/cmvr-center-list/cmvr-center-list.component.js